import * as actionTypes from './actionTypes';
import { validateService } from './services';
import { actionsModalError } from '@app/src/common/modalError';
import { isClientEnv } from '@app/src/utils/validations';

const isClient = isClientEnv();

const fetchValidateRequest = () => ({
  type: actionTypes.FETCH_VALIDATE_REQUEST
});

const fetchValidateFailure = () => ({
  type: actionTypes.FETCH_VALIDATE_FAILURE
});

const fetchValidateSuccess = (data) => ({
  type: actionTypes.FETCH_VALIDATE_SUCCESS,
  data
});

export const clearValidateData = () => ({
  type: actionTypes.CLEAR_VALIDATE_DATA
});

export const fetchValidate = () => {
  return async dispatch => {
    dispatch(fetchValidateRequest());
    try {
      const data = await validateService.post();
      if (data.error) {
        if (data.code === 400) {
          dispatch(actionsModalError.openModalError(data.message));
          isClient && localStorage.removeItem('user');
          setTimeout(() => {
            isClient && window.location.reload();
          }, 500);
        } else if (data.code === 401) {
          dispatch(actionsModalError.openModalError(data.message));
          isClient && localStorage.removeItem('user');
          setTimeout(() => {
            isClient && window.location.replace('/inicia-tu-sesion');
          }, 2000);
        } else {
          dispatch(fetchValidateFailure());
        }
      } else {
        dispatch(fetchValidateSuccess(data.data[0]));
        const user = JSON.parse(localStorage.getItem('user'));
        user['data'] = data.data[0];
        isClient && localStorage.setItem('user', JSON.stringify(user));
      }
    } catch(error) {
      console.log(`Error fetch validate action ${error}`);
      dispatch(actionsModalError.openModalError('Ocurrió un error'));
      dispatch(fetchValidateFailure());
    }
  }
}
